import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FileNotFoundIcon } from '../assets/icons/new/file-not-found.svg';

interface EmptyStateProps {
	title?: string;
	description?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description }) => {
	const { t } = useTranslation();

	return (
		<div className="empty-state">
			<FileNotFoundIcon className="empty-state__icon" />
			<p className="empty-state__title">{title || t('knowledgeBase.noResults')}</p>
			{description && <p className="empty-state__description">{description}</p>}
		</div>
	);
};
